import React from 'react';
import { Chip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

/**
 * Small "Coming Soon" chip for disabled-but-visible nav items.
 * MVP boundary marker — visually mutes a feature without hiding it.
 */
const ComingSoonBadge: React.FC = () => (
  <Chip
    icon={<AccessTimeIcon sx={{ fontSize: 14 }} />}
    label="Coming Soon"
    size="small"
    sx={{
      ml: 1,
      height: 20,
      fontSize: '0.7rem',
      bgcolor: '#E0F2F1',
      color: '#00796B',
      '& .MuiChip-icon': { color: '#00796B' },
    }}
  />
);

export default ComingSoonBadge;